export default () => ({ buildSHA: 'c2cbe1d61c0488b971eaaf8f108e1a8c871c468a' })
